import { Component, ViewEncapsulation } from '@angular/core';
import { BlogNewsComponent } from '@prekog/common-ui';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss'],
    imports: [BlogNewsComponent]
})
export class BlogComponent {}
